"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ONBOARDING_STUDENT: 'onboarding_student',
    TRIGGER_ALLOCATE_SSM: 'trigger_allocate_ssm',
    MANUAL_ASSIGN: 'manual_assign',
    UPDATE_STUDENT: 'update_student',
    UPDATE_STAFF: 'update_staff',
    USER_STATUS: 'user_status',
};
//# sourceMappingURL=allocationTopics.js.map